(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mega-menu-content"] && !Shopify.designMode) return;
  try {
    
  class MegaMenuContent {
    constructor(element) {
      this.element = element;
      this.menuItem = (element.dataset.menuItem || '').trim();
      this.header = document.querySelector('.header');
      this.width = element.dataset.width || 'full';
      this.customWidth = element.dataset.customWidth || '1200px';
      this.alignment = element.dataset.horizontalAlignment || 'center';
      this.reference = element.dataset.alignmentReference || 'container';
      this.preventOverflow = element.dataset.preventOverflow === 'true';
      this.trigger = element.dataset.trigger || 'hover';
      this.hoverTimeout = null;
      this.init();
    }

    init() {
      if (!this.header || !this.menuItem) {
        this.element.style.display = 'none';
        return;
      }

      // Localiza los <li> del nav cuyo texto coincida con menu_item (case-insensitive)
      const target = this.menuItem.toLowerCase();
      const items = Array.from(
        this.header.querySelectorAll('.menu-item.header-menu-first-level')
      ).filter((li) => {
        const link = li.querySelector('.first-level-link, .first-level-summary .link, a');
        const text = link ? link.textContent.trim().toLowerCase() : '';
        const handleMatch = li.className.toLowerCase().indexOf('item-' + target.replace(/\s+/g, '-')) !== -1;
        return text === target || handleMatch;
      });

      if (items.length === 0) {
        this.element.style.display = 'none';
        return;
      }

      items.forEach((li) => {
        li.classList.add('has-mega-menu');
        // Inyecta el caret si el ítem no tiene uno (links planos sin dropdown nativo)
        if (!li.querySelector('.menu-caret')) {
          const label = li.querySelector('.first-level-link') || li.querySelector('.first-level-summary') || li.querySelector('a');
          if (label) {
            const wrap = document.createElement('span');
            wrap.className = 'menu-caret-wrap';
            wrap.setAttribute('aria-hidden', 'true');
            wrap.innerHTML =
              '<svg class="menu-caret" width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">' +
              '<path d="M0.5 0.5L4.5 4.5L8.5 0.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
            label.appendChild(wrap);
          }
        }
      });
      this.items = items;

      // Clona a <body> para evitar clipping/stacking del header
      const existing = document.querySelector(
        '.mega-menu-clone[data-menu-item-clone="' + CSS.escape(this.menuItem) + '"]'
      );
      if (existing) existing.remove();

      const clone = this.element.cloneNode(true);
      clone.classList.add('mega-menu-clone');
      clone.dataset.menuItemClone = this.menuItem;
      this.clone = clone;
      document.body.appendChild(clone);

      this.bindClose(clone, items);
      this.bindLinks(clone, items);
      this.bindTriggers(items, clone);
      this.initSoloDetection(clone);
      this.initReactive(clone);
      this.initSubmenuSplit(clone);

      let lastWidth = window.innerWidth;
      const handleUpdate = () => {
        if (!clone.isConnected) {
          window.removeEventListener('scroll', handleUpdate);
          window.removeEventListener('resize', handleUpdate);
          return;
        }
        // Al cambiar el ancho, las alturas cambian: reinicia el bloqueo
        if (window.innerWidth !== lastWidth) {
          lastWidth = window.innerWidth;
          this.resetHeight(clone);
        }
        if (clone.classList.contains('is-active')) {
          const activeItem = items.find((li) => li.classList.contains('is-open')) || items[0];
          this.position(clone, activeItem);
          this.stabilizeHeight(clone);
        }
      };
      window.addEventListener('scroll', handleUpdate, { passive: true });
      window.addEventListener('resize', handleUpdate, { passive: true });

      // El original solo hace falta para re-render del editor de temas.
      // En producción lo quitamos para no duplicar nodos en el DOM.
      if (window.Shopify && window.Shopify.designMode) {
        this.element.style.display = 'none';
      } else {
        this.element.remove();
      }
    }

    open(clone, item) {
      clearTimeout(this.hoverTimeout);
      document.querySelectorAll('.mega-menu-content.is-active').forEach((m) => {
        if (m !== clone) m.classList.remove('is-active');
      });
      this.position(clone, item);
      clone.classList.add('is-active');
      item.classList.add('is-open');
      // Fija el alto de los paneles al más alto para evitar saltos al cambiar
      this.stabilizeHeight(clone);
    }

    // Mide el panel más alto de cada grupo reactivo/submenú y fija min-height
    // en el contenedor, de modo que cambiar de panel no altere el alto total.
    // Solo mide con el menú visible (anchos y aspect-ratio correctos).
    stabilizeHeight(clone) {
      if (this._heightLocked || !clone.classList.contains('is-active')) return;

      const groups = [];
      clone.querySelectorAll('[data-mega-reactive]').forEach((g) => {
        groups.push([g, '.mega-menu-content__reactive-panel']);
      });
      clone.querySelectorAll('.mega-menu-content__submenu-panels').forEach((g) => {
        groups.push([g, '.mega-menu-content__submenu-panel']);
      });

      groups.forEach((entry) => {
        const group = entry[0];
        const panels = Array.from(group.querySelectorAll(entry[1]));
        if (panels.length < 2) return;
        const wasActive = panels.map((p) => p.classList.contains('is-active'));
        // Muestra todos (sin repintar: se restaura antes de ceder el hilo)
        panels.forEach((p) => p.classList.add('is-active'));
        let max = 0;
        panels.forEach((p) => {
          if (p.offsetHeight > max) max = p.offsetHeight;
        });
        panels.forEach((p, i) => {
          if (!wasActive[i]) p.classList.remove('is-active');
        });
        if (max > 0) group.style.minHeight = max + 'px';
      });

      // Elementos reactivos por categoría (Content Wrappers y listas de links
      // reactivas). Cada uno es su propio "panel"; se agrupan por contenedor
      // padre para igualar alturas solo entre hermanos (no mezclar tipos) y
      // así evitar saltos al cambiar de categoría.
      const contentEls = Array.from(clone.querySelectorAll('[data-mega-content]'));
      const byParent = new Map();
      contentEls.forEach((el) => {
        const parent = el.parentElement;
        if (!byParent.has(parent)) byParent.set(parent, []);
        byParent.get(parent).push(el);
      });
      byParent.forEach((els) => {
        if (els.length < 2) return;
        const wasActive = els.map((e) => e.classList.contains('is-active'));
        els.forEach((e) => e.classList.add('is-active'));
        let max = 0;
        els.forEach((e) => {
          if (e.offsetHeight > max) max = e.offsetHeight;
        });
        els.forEach((e, i) => {
          if (!wasActive[i]) e.classList.remove('is-active');
        });
        if (max > 0) els.forEach((e) => { e.style.minHeight = max + 'px'; });
      });

      this._heightLocked = true;
    }

    resetHeight(clone) {
      this._heightLocked = false;
      clone
        .querySelectorAll(
          '[data-mega-reactive], .mega-menu-content__submenu-panels, [data-mega-content]'
        )
        .forEach((g) => {
          g.style.minHeight = '';
        });
    }

    close(clone) {
      clone.classList.remove('is-active');
      (this.items || []).forEach((li) => li.classList.remove('is-open'));
      // Restablece el contenido reactivo a la primera categoría
      if (this.reactiveActivate && this.reactiveDefault) {
        this.reactiveActivate(this.reactiveDefault);
      }
      if (this.reactiveActivateContent && this.reactiveDefaultContent) {
        this.reactiveActivateContent(this.reactiveDefaultContent);
      }
      // Restablece cada submenú en columna a su primer ítem
      (this.submenuResets || []).forEach((reset) => reset());
    }

    // Detección por categoría (nivel 1) de dos señales independientes: si le
    // falta el submenú (flyout) y/o el menú asociado (columna del medio). Marca
    // cada columna del grid por su contenido y construye dos mapas
    // handle -> boolean. El toggle de .is-flyout-empty / .is-middle-empty lo
    // hace activateContent en cada hover.
    initSoloDetection(clone) {
      this.soloEnabled = false;
      this.flyoutEmptyByKey = {};
      this.middleEmptyByKey = {};

      const inner = clone.querySelector('.mega-menu-content__inner');
      if (!inner) return;

      // Solo se activa si hay un bloque de productos reactivo con la opción puesta.
      const productsWrap = clone.querySelector(
        '.mega-menu-content__products--reactive[data-mega-solo-expand]'
      );
      if (!productsWrap) return;
      this.soloEnabled = true;

      // Clasifica cada columna directa del grid por lo que contiene.
      let hasSubmenuCol = false;
      let hasContentCol = false;
      const columns = Array.from(inner.children).filter((el) =>
        el.classList.contains('mega-menu-content__column')
      );
      columns.forEach((col) => {
        if (col.querySelector('.mega-menu-content__products--reactive')) {
          col.classList.add('is-solo-col-products');
        } else if (col.querySelector('[data-submenu-split]')) {
          col.classList.add('is-solo-col-submenu');
          hasSubmenuCol = true;
        } else if (col.querySelector('[data-mega-content], [data-mega-reactive-links]')) {
          col.classList.add('is-solo-col-content');
          hasContentCol = true;
        }
      });

      const hasText = (el) => !!el && el.textContent.trim().length > 0;

      // Un contenedor de contenido cuenta como "lleno" si tiene texto o imagen,
      // excluyendo los paneles de productos (que usan data-mega-panel).
      const contentIsFull = (key) => {
        const els = Array.from(
          clone.querySelectorAll('[data-mega-content="' + key + '"]')
        );
        return els.some((el) => hasText(el) || el.querySelector('img'));
      };

      // El flyout de una categoría está vacío si su panel (por índice) no tiene
      // contenido renderizado (Liquid solo pinta el panel si hay subniveles).
      const flyoutIsEmpty = (trigger) => {
        if (!trigger.hasAttribute('data-submenu-trigger')) return true;
        const split = trigger.closest('[data-submenu-split]');
        if (!split) return true;
        const idx = trigger.getAttribute('data-submenu-trigger');
        const panel = split.querySelector('[data-submenu-panel="' + idx + '"]');
        return !hasText(panel);
      };

      // Cada disparador de contenido de nivel 1 es una categoría candidata.
      const contentTriggers = Array.from(
        clone.querySelectorAll('[data-mega-content-trigger]')
      );
      contentTriggers.forEach((t) => {
        const key = t.getAttribute('data-mega-content-trigger');
        if (!key) return;
        // Cada señal se limita a que la columna correspondiente exista: si no
        // hay columna de submenú (o de menú), esa señal nunca colapsa nada.
        this.flyoutEmptyByKey[key] = hasSubmenuCol && flyoutIsEmpty(t);
        this.middleEmptyByKey[key] = hasContentCol && !contentIsFull(key);
      });
    }

    // Contenido reactivo. Dos niveles:
    //  - PRODUCTOS (data-mega-panel): reaccionan a nivel 1 Y nivel 2 (subniveles).
    //  - CONTENIDO (data-mega-content: Content Wrapper / Lista de links reactiva):
    //    reacciona SOLO a nivel 1 (data-mega-content-trigger) y se queda fijo al
    //    navegar los subniveles. Todo pre-renderizado.
    initReactive(clone) {
      const inner = clone.querySelector('.mega-menu-content__inner');
      const triggers = Array.from(clone.querySelectorAll('[data-mega-trigger]'));
      const panels = Array.from(clone.querySelectorAll('[data-mega-panel]'));
      const contentPanels = Array.from(clone.querySelectorAll('[data-mega-content]'));
      const contentTriggers = Array.from(clone.querySelectorAll('[data-mega-content-trigger]'));
      const hasContent = contentPanels.length > 0;
      if (!triggers.length && !contentTriggers.length) return;
      if (!panels.length && !hasContent) return;

      // "Ver todos": uno por bloque de productos reactivo. De cada uno se guarda
      // el ancla y su contenedor; se oculta el contenedor (no el ancla) para que
      // el hueco siga reservado y la columna de productos no salte en el hover.
      const viewAlls = Array.from(clone.querySelectorAll('[data-mega-view-all]')).map((a) => ({
        link: a,
        wrap: a.closest('.mega-menu-content__view-all-wrap') || a,
      }));

      // Nivel 1 + 2: productos y resaltado de disparadores de subnivel.
      const activate = (handle) => {
        if (!handle) return;
        panels.forEach((p) => {
          p.classList.toggle('is-active', p.getAttribute('data-mega-panel') === handle);
        });
        triggers.forEach((t) => {
          // El resaltado de los disparadores de nivel 1 lo gestionan
          // activateContent()/initSubmenuSplit; aquí solo los de subnivel.
          if (t.hasAttribute('data-mega-content-trigger') || t.hasAttribute('data-submenu-trigger')) return;
          t.classList.toggle('is-active', t.getAttribute('data-mega-trigger') === handle);
        });
      };

      // "Ver todos", aparte de activate(): se actualiza SOLO en el hover, nunca
      // al cerrar. Si close() reescribiera el href, lo haría dentro del listener
      // de click y el navegador acabaría yendo al destino reseteado; así el
      // enlace conserva el de el último hover.
      // Visibilidad: solo se muestra si el ítem hovereado tiene panel, que es
      // exactamente la condición de "es una colección" (Liquid solo pinta panel
      // para los links de tipo collection_link).
      const updateViewAll = (handle) => {
        if (!viewAlls.length) return;
        const matched = panels.find((p) => p.getAttribute('data-mega-panel') === handle);
        const url = matched ? matched.getAttribute('data-collection-url') : '';
        viewAlls.forEach((v) => {
          if (url) v.link.setAttribute('href', url);
          v.wrap.classList.toggle('is-hidden', !url);
        });
      };

      // Solo nivel 1: intercambia las regiones de contenido reactivo.
      const activateContent = (key) => {
        if (!key) return;
        contentPanels.forEach((w) => {
          w.classList.toggle('is-active', w.getAttribute('data-mega-content') === key);
        });
        contentTriggers.forEach((t) => {
          t.classList.toggle('is-active', t.getAttribute('data-mega-content-trigger') === key);
        });
        // Ajuste del layout según lo que tenga la categoría:
        //  - sin submenú -> encoge la columna del submenú (.is-flyout-empty)
        //  - sin menú asociado -> oculta la columna del medio (.is-middle-empty)
        // Los productos (cantidad y expansión) reaccionan a estas dos clases.
        if (inner && this.soloEnabled) {
          inner.classList.toggle('is-flyout-empty', this.flyoutEmptyByKey[key] === true);
          inner.classList.toggle('is-middle-empty', this.middleEmptyByKey[key] === true);
        }
      };

      triggers.forEach((t) => {
        const handle = t.getAttribute('data-mega-trigger');
        const contentKey = t.getAttribute('data-mega-content-trigger');
        const onEnter = () => {
          activate(handle);
          updateViewAll(handle);
          if (contentKey) activateContent(contentKey);
        };
        t.addEventListener('mouseenter', onEnter);
        t.addEventListener('focus', onEnter);
      });

      this.reactiveActivate = activate;
      this.reactiveActivateContent = activateContent;
      const firstTrigger = triggers[0] || contentTriggers[0];
      this.reactiveDefault = firstTrigger.getAttribute('data-mega-trigger');
      this.reactiveDefaultContent =
        firstTrigger.getAttribute('data-mega-content-trigger') ||
        firstTrigger.getAttribute('data-mega-trigger');
      // Estado inicial: primera categoría (nivel 1). El "Ver todos" se ajusta
      // aquí una sola vez porque activate() ya no lo toca; si no, se quedaría
      // con el href='#' del Liquid y visible aunque no fuese una colección.
      activate(this.reactiveDefault);
      activateContent(this.reactiveDefaultContent);
      updateViewAll(this.reactiveDefault);
    }

    // Submenú en columna a la derecha: al pasar el ratón sobre un ítem de la
    // izquierda (data-submenu-trigger) muestra su panel de subniveles
    // (data-submenu-panel). Cada contenedor [data-submenu-split] es independiente.
    initSubmenuSplit(clone) {
      const splits = Array.from(clone.querySelectorAll('[data-submenu-split]'));
      this.submenuResets = this.submenuResets || [];

      splits.forEach((split) => {
        const triggers = Array.from(split.querySelectorAll('[data-submenu-trigger]'));
        const panels = Array.from(split.querySelectorAll('[data-submenu-panel]'));
        if (!triggers.length || !panels.length) return;

        const activate = (key) => {
          panels.forEach((p) => {
            p.classList.toggle('is-active', p.getAttribute('data-submenu-panel') === key);
          });
          triggers.forEach((t) => {
            t.classList.toggle('is-active', t.getAttribute('data-submenu-trigger') === key);
          });
        };

        triggers.forEach((t) => {
          const key = t.getAttribute('data-submenu-trigger');
          t.addEventListener('mouseenter', () => activate(key));
          t.addEventListener('focus', () => activate(key));
        });

        const defaultKey = triggers[0].getAttribute('data-submenu-trigger');
        this.submenuResets.push(() => activate(defaultKey));
        activate(defaultKey);
      });
    }

    bindTriggers(items, clone) {
      items.forEach((item) => {
        if (this.trigger === 'click') {
          const link = item.querySelector('.first-level-link, .first-level-summary .link, a');
          if (link) {
            link.addEventListener('click', (e) => {
              if (window.innerWidth <= 989) return;
              e.preventDefault();
              e.stopPropagation();
              if (clone.classList.contains('is-active')) this.close(clone);
              else this.open(clone, item);
            });
          }
        } else {
          item.addEventListener('mouseenter', () => this.open(clone, item));
          item.addEventListener('mouseleave', () => {
            this.hoverTimeout = setTimeout(() => this.close(clone), 120);
          });
        }
      });

      if (this.trigger === 'hover') {
        clone.addEventListener('mouseenter', () => clearTimeout(this.hoverTimeout));
        clone.addEventListener('mouseleave', () => {
          this.hoverTimeout = setTimeout(() => this.close(clone), 120);
        });
      } else {
        document.addEventListener('click', (e) => {
          const onItem = items.some((li) => li.contains(e.target));
          if (!clone.contains(e.target) && !onItem) this.close(clone);
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && clone.classList.contains('is-active')) this.close(clone);
      });
    }

    bindClose(clone, items) {
      const btn = clone.querySelector('[data-mega-menu-close]');
      if (btn) {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.close(clone);
        });
      }
    }

    bindLinks(clone, items) {
      clone.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => {
          if (link.hasAttribute('data-mega-menu-close')) return;
          this.close(clone);
        });
      });
    }

    // Contenedor de referencia = la franja page-width del header
    // (con menu_position: bottom la nav vive en .header-nav .page-width;
    //  si no, se usa .header-main que también es page-width).
    getContainer() {
      return (
        this.header.querySelector('.header-nav .page-width') ||
        this.header.querySelector('.header-main') ||
        this.header
      );
    }

    position(clone, item) {
      const headerRect = this.header.getBoundingClientRect();
      const container = this.getContainer();
      const containerRect = container.getBoundingClientRect();
      // Caja de CONTENIDO del contenedor: resta su padding horizontal para
      // alinear con el contenido visible del header (logo/nav), no con el
      // borde exterior del .page-width (que incluye ese padding).
      const cs = window.getComputedStyle(container);
      const padLeft = parseFloat(cs.paddingLeft) || 0;
      const padRight = parseFloat(cs.paddingRight) || 0;
      const containerContent = {
        left: containerRect.left + padLeft,
        width: containerRect.width - padLeft - padRight,
      };
      containerContent.right = containerContent.left + containerContent.width;
      const viewport = window.innerWidth;
      const margin = 16;
      const isFull = this.width === 'full';

      // Posición vertical: justo debajo de todo el header (incluida la fila de nav)
      clone.classList.toggle('mega-menu-content--full-width', isFull);
      clone.style.position = 'fixed';
      clone.style.zIndex = '11000';
      clone.style.top = headerRect.bottom + 'px';
      clone.style.maxHeight = 'calc(100dvh - ' + headerRect.bottom + 'px)';
      clone.style.right = 'auto';
      clone.style.setProperty('--mega-menu-transform', 'none');

      // Ancho completo de pantalla (edge-to-edge)
      if (isFull) {
        clone.style.left = '0';
        clone.style.width = '100%';
        clone.style.maxWidth = '100dvw';
        return;
      }

      // Ancho del panel (px) según el modo
      let panelWidth;
      switch (this.width) {
        case 'container': panelWidth = containerContent.width; break;
        case 'large': panelWidth = Math.min(1200, viewport - margin * 2); break;
        case 'medium': panelWidth = Math.min(900, viewport - margin * 2); break;
        case 'small': panelWidth = Math.min(600, viewport - margin * 2); break;
        case 'custom': panelWidth = parseFloat(this.customWidth) || containerContent.width; break;
        default: panelWidth = containerContent.width; break;
      }

      // Base de alineación: contenido del contenedor page-width o el ítem padre del nav
      const ref = this.reference === 'parent' ? item.getBoundingClientRect() : containerContent;
      let left;
      if (this.alignment === 'left') {
        left = ref.left;
      } else if (this.alignment === 'right') {
        left = ref.right - panelWidth;
      } else {
        left = ref.left + (ref.width - panelWidth) / 2;
      }

      // Evitar desbordes: mantener dentro del viewport
      if (this.preventOverflow) {
        if (left + panelWidth > viewport - margin) left = viewport - margin - panelWidth;
        if (left < margin) left = margin;
      }

      clone.style.width = panelWidth + 'px';
      clone.style.maxWidth = 'calc(100dvw - ' + margin * 2 + 'px)';
      clone.style.left = Math.round(left) + 'px';
    }
  }

  function initMegaMenus() {
    document
      .querySelectorAll('.mega-menu-content:not(.mega-menu-clone):not([data-mega-menu-initialized])')
      .forEach((menu) => {
        menu.setAttribute('data-mega-menu-initialized', 'true');
        new MegaMenuContent(menu);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenus);
  } else {
    initMegaMenus();
  }
  window.addEventListener('load', initMegaMenus);
  document.addEventListener('shopify:section:load', initMegaMenus);

  } catch(e) { console.error(e); }
})();
})();
